import { Component, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties/StringProperty';
import { BearingSchema } from './BearingSchema';
import { DimensionSchema } from './DimensionSchema';
import { MemberSchema } from './MemberSchema';
import { PlatePairSchema } from './PlatePairSchema';
import { ReferenceLineSchema } from './ReferenceLineSchema';
import { SpliceSchema } from './SpliceSchema';

// TODO: there are several kinds of components
export const ComponentSchema = new ModelSchema<Component>('component', {
  category: ModelCategory.ComponentDesignData,

  properties: {
    name: StringProperty,
    componentType: StringProperty.configure({ readOnly: true }),
    // TODO: everything else
  },

  children: {
    members: MemberSchema,
    platePairs: PlatePairSchema,
    bearings: BearingSchema,
    dimensions: DimensionSchema,
    referenceLines: ReferenceLineSchema,
    splices: SpliceSchema,
  },
});
